"use strict";

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.parse-int.js";
jQuery(function () {
  var resize_iframes = function resize_iframes() {
    jQuery('.entry-content iframe').css({
      'margin': '10px auto',
      'max-width': 'none'
    });
    if (jQuery('.entry-content').length) {
      var entry_content_width = jQuery('.entry-content').width();
      jQuery(".entry-content iframe").each(function (item) {
        var $iframe = jQuery(this);
        if (!$iframe.data('iframe_ratio')) {
          if ($iframe.attr('width') && !$iframe.attr('width').match(/%/)) {
            $iframe.data('iframe_ratio', 1.1 * parseInt($iframe.attr('height'), 10) / parseInt($iframe.attr('width'), 10));
          } else {
            $iframe.data('iframe_ratio', 1.5);
          }
        }
        var src = $iframe.attr('src');
        if ($iframe.data('iframe_ratio')) {
          $iframe.attr('width', entry_content_width);
          $iframe.attr('height', entry_content_width * $iframe.data('iframe_ratio'));
        }
      });
    }
  };
  resize_iframes();
  jQuery(window).on('load', resize_iframes);
  jQuery(window).on('debouncedresize', resize_iframes);
});